import { useEffect, useState } from 'react';

import { useAppDispatch, useAppSelector } from '@/shared/hooks';

import { organizationModel } from '@/entities/organization';
import { templatesModel } from '@/entities/templates';

// The clinic's encounter schemas and document templates the recording
// pop-up and the template library read, loaded once for the current
// organization.
export const useWorkspaceCatalog = () => {
  const dispatch = useAppDispatch();
  const [loadError, setLoadError] = useState(false);
  const [loadAttempt, setLoadAttempt] = useState(0);
  const [requested, setRequested] = useState(false);
  const organizationId = useAppSelector(
    organizationModel.selectors.selectRelevantOrganizationID,
  );
  const language = useAppSelector(
    organizationModel.selectors.selectRelevantOrganizationLanguage,
  );
  const enabled = useAppSelector(
    organizationModel.selectors.selectTranscriptorV2Enabled,
  );
  const schemas = useAppSelector(
    templatesModel.selectors.selectPublishedEncounterSchemas,
  );
  const documentTemplates = useAppSelector(
    templatesModel.selectors.selectActiveDocumentTemplates,
  );
  const templateVersions = useAppSelector(
    templatesModel.selectors.selectDocumentTemplatesById,
  );
  const documentTemplatesLoading = useAppSelector(
    templatesModel.selectors.selectDocumentTemplatesLoading,
  );

  useEffect(() => {
    if (!organizationId) {
      return;
    }
    let active = true;
    const request = {
      organization_id: organizationId,
      ...(enabled && language ? { language } : {}),
    };
    setLoadError(false);
    setRequested(true);
    void Promise.all([
      dispatch(templatesModel.fetchEncounterSchemas(request)).unwrap(),
      dispatch(templatesModel.fetchDocumentTemplates(request)).unwrap(),
    ]).catch(() => {
      if (active) {
        setLoadError(true);
      }
    });
    return () => {
      active = false;
    };
  }, [organizationId, language, enabled, loadAttempt]);

  return {
    schemas,
    documentTemplates,
    templateVersions,
    templatesLoading: !requested || documentTemplatesLoading,
    loadError,
    retry: () => setLoadAttempt((current) => current + 1),
  };
};
